import React from 'react';
import BRSpan from '../../General/BRSpan';

export default props => {

  return (
    <li className="newark__donor-list-item" key={'donor-list-item-' + props.donor.id}>
      <BRSpan str={props.donor.name}/>
    </li>
  );
};


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkDonorListItem.js